import React, { useEffect } from "react";
// plugin that creates slider
import Slider from "nouislider";
// react component plugin for creating beatiful tags on an input
import TagsInput from "react-tagsinput";
import classNames from "classnames";
import { useLocation } from "react-router";
import Popover from "@material-ui/core/Popover";
import { Link } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import Radio from "@material-ui/core/Radio";
import Switch from "@material-ui/core/Switch";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";

import InfoArea from "components/InfoArea/InfoArea.js";
import VerifiedUser from "@material-ui/icons/VerifiedUser";
import LocalShipping from "@material-ui/icons/LocalShipping";
import KeyboardReturnIcon from "@material-ui/icons/KeyboardReturn";
import GavelIcon from "@material-ui/icons/Gavel";
import PaymentIcon from "@material-ui/icons/Payment";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";

import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";

// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";
import People from "@material-ui/icons/People";
import Check from "@material-ui/icons/Check";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.js";
import Paginations from "components/Pagination/Pagination.js";
import Badge from "components/Badge/Badge.js";
import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";

import ImageGallery from "react-image-gallery";
import Accordion from "components/Accordion/Accordion.js";
import Tooltip from "@material-ui/core/Tooltip";
import ShoppingCart from "@material-ui/icons/ShoppingCart";
import SweetAlert from "react-bootstrap-sweetalert";

import cardProduct1 from "assets/img/examples/card-product1.jpg";
import cardProduct3 from "assets/img/examples/card-product3.jpg";
import cardProduct4 from "assets/img/examples/card-product4.jpg";
import cardProduct2 from "assets/img/examples/card-product2.jpg";
import product1 from "assets/img/examples/product1.jpg";
import product2 from "assets/img/examples/product2.jpg";
import product3 from "assets/img/examples/product3.jpg";
import product4 from "assets/img/examples/product4.jpg";

import { headApi, credentials, convertToNextTenth } from "utils/headApi";

import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";
import radio from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";
import popOver from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";
import style from "assets/jss/material-kit-pro-react/components/buttonStyle.js";

const useStyles = makeStyles(basicsStyle);
const useStyle = makeStyles(radio);
const useStylPop = makeStyles(popOver);
const useStyleAlert = makeStyles(style);

const useStylesPop = makeStyles((theme) => ({
  popoverPaper: {
    padding: "10px", // 🔹 left and right = 10px
    maxWidth: 1000,
    backgroundColor: "#585858"
  },
  popoverInner: {
    display: "flex",
    flexDirection: "column",
    maxHeight: 300,
    overflowY: "auto",
  },
  popoverHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between", // 🔹 Title left, close button right
    borderBottom: "1px solid #eee",
    paddingBottom: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
  },
  title: {
    fontWeight: 600,
    fontSize: "1rem",
    flex: 1, // ensures it uses remaining space
    color: "white"
  },
  description: {
    color: "white"
  },
  // infoClickable: {
  //   cursor: "pointer",
  // },

  infoGrid: {
    marginBottom: theme.spacing(1), // less vertical gap between rows
  },
  infoItem: {
    marginBottom: theme.spacing(-5), // reduce bottom space between cards
    paddingBottom: theme.spacing(0.5),
  },
  infoClickable: {
    cursor: "pointer",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    "&:hover": {
      transform: "translateY(-2px)",
    },
  },
  // Customize the InfoArea layout
  // infoArea: {
  //   "& h4, & h5, & h6": {
  //     fontSize: "0.9rem", // 🔹 Title size
  //     fontWeight: 600,
  //     textAlign: "center",
  //     marginTop: theme.spacing(-10),
  //     marginBottom: 0,
  //   },
  //   "& svg": {
  //     fontSize: "2.2rem",
  //     marginBottom: theme.spacing(-2), // ✅ Add this line
  //   },
  //   "& .MuiTypography-root": {
  //     marginBottom: theme.spacing(0), // ✅ Remove bottom gap from title
  //     marginTop: theme.spacing(0),    // ✅ Remove top gap from title
  //   },
  // },
  infoArea: {
    display: "flex",
    flexDirection: "column", // 🔹 Stack icon above title
    alignItems: "center",    // 🔹 Center horizontally
    justifyContent: "center",
    textAlign: "center",
    marginBottom: -50,

    "& svg": {
      fontSize: "2.2rem", // Icon size
      marginBottom: theme.spacing(-3), // Small space between icon & title
    },

    "& h4, & h5, & h6": {
      fontSize: "0.9rem",
      fontWeight: 600,
      marginTop: 0,
      marginBottom: 0, // 🔹 Remove bottom space below title
    },

    "& .MuiTypography-root": {
      marginTop: 0,
      marginBottom: 0, // 🔹 Remove bottom margin from Typography
      padding: 0,      // 🔹 Remove any padding
    },

    "& > *": {
      marginBottom: 0, // 🔹 Safety reset for all children
      paddingBottom: 0,
    },
  },

}));

export default function ProductImage() {
  const [colorSelect, setColorSelect] = React.useState("0");
  const [sizeSelect, setSizeSelect] = React.useState("0");
  const [prodObject, setProdObject] = React.useState({});
  const [imageGal, setImageGal] = React.useState([]);
  const [prodList, setProdList] = React.useState([]);
  const [sets, setSets] = React.useState("");
  const [box, setBox] = React.useState("");
  const [packing, setPacking] = React.useState("");
  const [labourList, setLobourList] = React.useState("");
  const [metal, setMetal] = React.useState("");
  const [proTotal, setProTotal] = React.useState("");
  const [cat, setCat] = React.useState("");
  const [catMM, setCatMM] = React.useState("");

  const [logMsg, setLogMsg] = React.useState("");

  const [checkedFullSize, setCheckedFullSize] = React.useState(true);
  const [checkedCutSize, setCheckedCutSize] = React.useState(false);

  const [submitted, setSubmitted] = React.useState(false);
  const [alertMsg, alertMsgOps] = React.useState("");
  const [alertType, alertTypeOps] = React.useState("");

  const [anchorElTop, setAnchorElTop] = React.useState(null);
  const [size1x8, setSize1x8] = React.useState(0);
  const [size1x9, setSize1x9] = React.useState(0);
  const [size1x10, setSize1x10] = React.useState(0);
  const [size1x11, setSize1x11] = React.useState(0);
  const [size1x12, setSize1x12] = React.useState(0);
  const [size1x13, setSize1x13] = React.useState(0);
  const [size1x14, setSize1x14] = React.useState(0);
  const [size1x15, setSize1x15] = React.useState(0);
  const [size2x0, setSize2x0] = React.useState(0);
  const [size2x1, setSize2x1] = React.useState(0);
  const [size2x2, setSize2x2] = React.useState(0);
  const [size2x3, setSize2x3] = React.useState(0);
  const [size2x4, setSize2x4] = React.useState(0);
  const [size2x5, setSize2x5] = React.useState(0);
  const [size2x6, setSize2x6] = React.useState(0);
  const [size2x7, setSize2x7] = React.useState(0);
  const [size2x8, setSize2x8] = React.useState(0);
  const [size2x9, setSize2x9] = React.useState(0);
  const [size2x10, setSize2x10] = React.useState(0);
  const [size2x11, setSize2x11] = React.useState(0);
  const [size2x12, setSize2x12] = React.useState(0);
  const [size2x13, setSize2x13] = React.useState(0);
  const [size2x14, setSize2x14] = React.useState(0);
  const [size2x15, setSize2x15] = React.useState(0);
  const [size3x0, setSize3x0] = React.useState(0);
  const [size3x1, setSize3x1] = React.useState(0);
  const [comment, setComment] = React.useState(
    "Mix different four sizes in one design, or mix different six designs in one size, or one design in one size."
  );

  const [checked, setChecked] = React.useState([24, 22]);
  const [selectedEnabled, setSelectedEnabled] = React.useState("b");
  const [checkedA, setCheckedA] = React.useState(true);
  const [checkedB, setCheckedB] = React.useState(false);
  const [simpleSelect, setSimpleSelect] = React.useState("");
  const [multipleSelect, setMultipleSelect] = React.useState([]);
  const [tags, setTags] = React.useState([
    "amsterdam",
    "washington",
    "sydney",
    "beijing",
  ]);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedInfo, setSelectedInfo] = React.useState(null);

  const activeSession = sessionStorage.getItem("sessionData");
  const clientObj = JSON.parse(sessionStorage.getItem("sessionData"));

  const search = useLocation().search;
  const a = new URLSearchParams(search).get("a");
  const p = new URLSearchParams(search).get("p");
  const category = new URLSearchParams(search).get("category");
  const state = new URLSearchParams(search).get("state");
  const catSize = new URLSearchParams(search).get("catSize");
  const country = new URLSearchParams(search).get("country");

  const classes = useStyles();
  const classe = useStyle();
  const classPop = useStylPop();
  const classeAlert = useStyleAlert();
  const classesPop = useStylesPop();

  async function getProd() {
    const results = await fetch(headApi + `/product/findById/${p}`, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const res = await results.json();
    // console.log(res);
    setProdObject(res);

    setImageGal(
      res.productimage.map((c) => {
        return {
          original: c.cpanelPath,
          thumbnail: c.cpanelPath,
        };
      })
    );

    setCat(res.category);
    setCatMM(res.parent);
    setSets(res.sets);
    setBox(res.box);
    setPacking(res.packingMaterial);
    setLobourList(res.productchild);
    setMetal(res.rawPrice);
    setProTotal(res.stockSize.length);
  }

  useEffect(() => {
    getProd();
  }, []);

  // const totalPiece = Math.ceil("864" / sets.pcs / box.box);
  const totalPiece =
    checkedFullSize === true
      ? checkedCutSize === true
        ? Math.floor(prodObject.moq / 2 / 6)
        : checkedFullSize === true
          ? Math.floor(prodObject.moq / 1 / 6)
          : "0"
      : checkedCutSize === true
        ? Math.floor(prodObject.moq / 1 / 6)
        : "0";

  var indianQty =
    parseInt(size1x8) +
    parseInt(size1x10) +
    parseInt(size1x12) +
    parseInt(size1x14) +
    parseInt(size2x0) +
    parseInt(size2x2) +
    parseInt(size2x4) +
    parseInt(size2x6) +
    parseInt(size2x8) +
    parseInt(size2x10) +
    parseInt(size2x12) +
    parseInt(size2x14) +
    parseInt(size3x0);

  var usQty =
    parseInt(size1x9) +
    parseInt(size1x11) +
    parseInt(size1x13) +
    parseInt(size1x15) +
    parseInt(size2x1) +
    parseInt(size2x3) +
    parseInt(size2x5) +
    parseInt(size2x7) +
    parseInt(size2x9) +
    parseInt(size2x11) +
    parseInt(size2x13) +
    parseInt(size2x15) +
    parseInt(size3x1);

  const FullAndCutSizeTotal = prodObject.moq - (indianQty + usQty);

  const images = [
    {
      original: product3,
      thumbnail: product3,
    },
    {
      original: product4,
      thumbnail: product4,
    },
    {
      original: product1,
      thumbnail: product1,
    },
    {
      original: product2,
      thumbnail: product2,
    },
  ];

  const handleEnquiry = async () => {
    const get = headApi + `/adminAddress/byId/${a}`;
    const result = await fetch(get, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const rest = await result.json();

    // console.log(
    //   "Company:- ",
    //   rest && rest.company ? rest.company : rest.firstName + " " + rest.lastName
    // );

    // console.log("Name:- ", rest.firstName + " " + rest.lastName);

    // console.log(
    //   "Address:- ",
    //   rest.plotHouseNo +
    //     " " +
    //     rest.areaColony +
    //     " " +
    //     rest.landMark +
    //     " " +
    //     rest.road +
    //     " - " +
    //     rest.zipCode +
    //     " " +
    //     rest.city +
    //     ", " +
    //     rest.state +
    //     ", " +
    //     rest.country
    // );

    // console.log("prod Id:- ", prodObject.id);
    // console.log("Admin Id:- ", prodObject.pAdminid);
    // console.log(
    //   "Amount:- ",
    //   prodObject.gstCash === true ? prodObject.taxInclude : prodObject.cashPrice
    // );
    // console.log("Gst:- ", prodObject.gstCash);
    // console.log(
    //   "Total Quantity:- ",
    //   prodObject.gstCash === true
    //     ? (prodObject.taxInclude * (indianQty + usQty)).toFixed(2)
    //     : (prodObject.cashPrice * (indianQty + usQty)).toFixed(2)
    // );

    // console.log(
    //   "size1x8:- ",
    //   size1x8 + " " + "size1x10:- ",
    //   size1x10 + " " + "size1x12:- ",
    //   size1x12 + " " + "size1x14: -",
    //   size1x14 + " " + "size2x0:- ",
    //   size2x0 + " " + "size2x2:- ",
    //   size2x2 + " " + "size2x4:- ",
    //   size2x4 + " " + "size2x6:- ",
    //   size2x6 + " " + "size2x8:- ",
    //   size2x8 + " " + "size2x10: -",
    //   size2x10 + " " + "size2x12:- ",
    //   size2x12 + " " + "size2x14:- ",
    //   size2x14 + " " + "size3x0:- ",
    //   size3x0
    // );

    // console.log(
    //   "size1x9",
    //   size1x9 + " " + "size1x11:- ",
    //   size1x11 + " " + "size1x13:- ",
    //   size1x13 + " " + "size1x15:- ",
    //   size1x15 + " " + "size2x1:- ",
    //   size2x1 + " " + "size2x3:- ",
    //   size2x3 + " " + "size2x5:- ",
    //   size2x5 + " " + "size2x7:- ",
    //   size2x7 + " " + "size2x9:- ",
    //   size2x9 + " " + "size2x11:- ",
    //   size2x11 + " " + "size2x13:- ",
    //   size2x13 + " " + "size2x15:- ",
    //   size2x15 + " " + "size3x1:- ",
    //   size3x1
    // );

    const size =
      "size1x8:- " +
      size1x8 +
      " " +
      "size1x10:- " +
      size1x10 +
      " " +
      "size1x12:- " +
      size1x12 +
      " " +
      "size1x14:- " +
      size1x14 +
      " " +
      "size2x0:- " +
      size2x0 +
      " " +
      "size2x2:- " +
      size2x2 +
      " " +
      "size2x4:- " +
      size2x4 +
      " " +
      "size2x6:- " +
      size2x6 +
      " " +
      "size2x8:- " +
      size2x8 +
      " " +
      "size2x10:- " +
      size2x10 +
      " " +
      "size2x12:- " +
      size2x12 +
      " " +
      "size2x14:- " +
      size2x14 +
      " " +
      "size3x0:- " +
      size3x0 +
      " " +
      "size1x9:- " +
      size1x9 +
      " " +
      "size1x11:- " +
      size1x11 +
      " " +
      "size1x13:- " +
      size1x13 +
      " " +
      "size1x15:- " +
      size1x15 +
      " " +
      "size2x1:- " +
      size2x1 +
      " " +
      "size2x3:- " +
      size2x3 +
      " " +
      "size2x5:- " +
      size2x5 +
      " " +
      "size2x7:- " +
      size2x7 +
      " " +
      "size2x9:- " +
      size2x9 +
      " " +
      "size2x11:- " +
      size2x11 +
      " " +
      "size2x13:- " +
      size2x13 +
      " " +
      "size2x15:- " +
      size2x15 +
      " " +
      "size3x1:- " +
      size3x1;

    // console.log(size);

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Basic ${credentials}`,
      },
      body: JSON.stringify({
        adminId: prodObject.pAdminid,
        productId: prodObject.id,
        clientId: clientObj.id,
        firstName: clientObj.firstname,
        lastName: clientObj.lastname,
        company: clientObj.company,
        mobile: clientObj.mobile,
        email: clientObj.email,
        type: clientObj.type,
        message: size,
      }),
    };

    fetch(headApi + "/enquiry/add", requestOptions)
      .then((response) => response.json())
      .then((data) => {
        // console.log(data);
        if (data.message === "Data Inserted Successfully !!!") {
          alertTypeOps("success");
          alertMsgOps("Succesfully Sent!");
          setSubmitted(true);
        }
      });
  };

  const hideAlert = () => {
    setSubmitted(false);
    window.location.reload(false);
  };

  // 🔹 All your InfoArea data centralized
  const infoList = [
    {
      title: "RETURN POLICY",
      description:
        "We offer a lifetime return policy on all purchases within India. The product along with the Bill can be returned on its current market value. We will give the fresh lot of bangles in return for the products with deductions towards making charges and processing charges.",
      icon: KeyboardReturnIcon,
      iconColor: "success",
    },
    {
      title: "POPULAR ITEMS",
      description:
        "Our 5MM and 8MM products are best sellers in India as well as foreign countries like Bangladesh, USA, UAE and Iran. Some of our popular brands are Omega Bangles, Royal Arts Bangles, Madam Asmi and Evershine bangles.",
      icon: Favorite,
      iconColor: "rose",
    },
    {
      title: "REFUND POLICY",
      description:
        "You are liable to get the full refund only after the returns of goods within 30 days of purchase, in case of goods received of different quality, design or size.",
      icon: VerifiedUser,
      iconColor: "success",
    },
    {
      title: "DELIVERY POLICY",
      description:
        "The order will be delivered within 25 working days in India from the date of payment and it will take a minimum 90 working days to be delivered outside India.",
      icon: LocalShipping,
      iconColor: "info",
    },
    {
      title: "Eligibility for Returns",
      description: "Items are eligible for return if they: Are unused, unworn, and in their original condition. Include all original packaging, certificates, and tags. Are returned within [specific time frame, e.g., 30 days] from the delivery date. Custom-made, engraved, or personalized jewelry items are not eligible for return unless they arrive damaged or defective.",
      icon: KeyboardReturnIcon,
      iconColor: "success",
    },
    {
      title: "Return Process",
      description: "Initiate a Return: Contact us at [support email/contact information] within [time frame, e.g., 7 days] of receiving your item. Provide your order number and a brief description of the reason for the return.",
      icon: KeyboardReturnIcon,
      iconColor: "rose",
    },
    {
      title: "Return Approval",
      description: "Once approved, we will provide you with a return shipping address and instructions.",
      icon: KeyboardReturnIcon,
      iconColor: "success",
    },
    {
      title: "Shipping the Return",
      description: "Customers are responsible for return shipping costs unless the item is damaged or defective. We recommend using a trackable shipping method to ensure the safe return of the item.",
      icon: LocalShipping,
      iconColor: "info",
    },
    {
      title: "Refunds",
      description: "Refunds will be issued to the original payment method within [time frame, e.g., 7–10 business days] after we receive and inspect the returned item. Shipping fees, customs duties, and taxes are non-refundable, except in cases where the item was damaged or defective upon arrival.",
      icon: VerifiedUser,
      iconColor: "success",
    },
    {
      title: "Exchanges",
      description: "Exchanges are allowed for items of equal or lesser value, subject to stock availability. The exchange process must be initiated within the return time frame.",
      icon: Favorite,
      iconColor: "rose",
    },
    {
      title: "Non-Returnable Items",
      description: "The following items cannot be returned: Custom or personalized jewelry. Sale or clearance items (if applicable). Items not returned in their original condition.",
      icon: KeyboardReturnIcon,
      iconColor: "success",
    },
    {
      title: "Damaged or Defective Items",
      description: "If you receive a damaged or defective item, contact us immediately at [support email/contact information]. Please provide photos of the item and packaging as proof. We will offer a replacement, repair, or full refund at no additional cost.",
      icon: LocalShipping,
      iconColor: "info",
    },
    {
      title: "International Returns",
      description: "International customers are responsible for all return shipping fees, including customs duties and taxes, unless the item is damaged or defective.",
      icon: KeyboardReturnIcon,
      iconColor: "success",
    },
    {
      title: "GOVERNING LAW",
      description:
        "These Terms and Conditions, and any disputes or claims arising from or in connection with them, shall be governed by and construed in accordance with the laws of [Your Jurisdiction/Country], without regard to its conflict of law principles. By using [Your App Name], you agree to submit to the exclusive jurisdiction of the courts located in [Your Jurisdiction/Country] to resolve any disputes or claims. If you are accessing [Your App Name] from outside [Your Jurisdiction/Country], you are responsible for compliance with local laws and regulations.",
      icon: GavelIcon,
      iconColor: "success",
    },
    {
      title: "ORDERS & PAYMENT",
      description:
        "Placing an Order By placing an order on [Your App Name], you agree to provide accurate, current, and complete information. All orders are subject to availability. We reserve the right to refuse or cancel any order for any reason, including errors in product descriptions, pricing, or availability. Once an order is placed, you will receive an email confirmation. This confirmation does not guarantee acceptance of your order. Pricing and Currency All prices are listed in [Default Currency] and may vary based on the currency exchange rates for international orders. Prices include applicable taxes unless otherwise stated. Additional shipping fees, customs duties, or taxes for international orders are the customer’s responsibility. Accepted Payment Methods We accept the following payment methods: Credit and debit cards (e.g., Visa, MasterCard, etc.) Online payment gateways (e.g., PayPal, Stripe, etc.) [Any other payment options relevant to your app]",
      icon: PaymentIcon,
      iconColor: "success",
    },
    {
      title: "TERMS & CONDITIONS",
      description:
        "By accessing and using [Your App Name], you confirm that: You are at least 18 years of age or have the legal consent of a parent or guardian to use our services. You have the legal capacity to enter into binding agreements. You are using the app in compliance with all applicable local, state, national, and international laws and regulations. You will provide accurate and complete information when creating an account or placing an order. We reserve the right to refuse service, terminate accounts, or cancel orders if we suspect any activity that violates these terms, including fraudulent behavior or providing false information.",
      icon: AssignmentTurnedInIcon,
      iconColor: "success",
    },
  ];

  // 🔹 Handle click to open Popover
  const handleIconClick = (event, info) => {
    setAnchorEl(event.currentTarget);
    setSelectedInfo(info);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedInfo(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div className={classes.sections}>
      <div className={classes.container}>
        {/* <div className={classes.title}>
          <h2>Basic Elements</h2>
        </div> */}
        {submitted ? (
          <SweetAlert
            type={alertType}
            style={{ display: "block", marginTop: "100px" }}
            title={alertMsg}
            onConfirm={() => hideAlert()}
            confirmBtnCssClass={classeAlert.button + " " + classeAlert.success}
          >
            added to the Enquiry!!
          </SweetAlert>
        ) : null}
        <div id="productImage" className="cd-section">
          <GridContainer>
            <GridItem md={6} sm={6}>
              <ImageGallery
                showFullscreenButton={false}
                showPlayButton={false}
                startIndex={0}
                showIndex={true}
                items={imageGal}
                showThumbnails={true}
                renderLeftNav={(onClick, disabled) => {
                  return (
                    <button
                      className="image-gallery-left-nav"
                      disabled={disabled}
                      onClick={onClick}
                    />
                  );
                }}
                renderRightNav={(onClick, disabled) => {
                  return (
                    <button
                      className="image-gallery-right-nav"
                      disabled={disabled}
                      onClick={onClick}
                    />
                  );
                }}
              />
            </GridItem>
            <GridItem md={6} sm={12} xs={12}>
              <GridContainer>
                <GridItem md={6} sm={6} xs={12}>
                  <span className={classes.mainPrice}>
                    <strong>
                      Item Code:{" "}
                      {prodObject.itemCodeNumber + "-" + prodObject.id}
                    </strong>
                  </span>
                </GridItem>
                <GridItem md={6} sm={6} xs={12}>
                  <span className={classes.mainPrice}>
                    <strong>
                      {prodObject && prodObject.gstCash === true ? (
                        <>
                          <h5>
                            <span style={{ color: "red" }}>
                              ₹{" "}
                              {convertToNextTenth(prodObject && prodObject.taxInclude) + " Inc."}
                            </span>
                          </h5>
                        </>
                      ) : (
                        <>
                          <h5>
                            <span style={{ color: "black" }}>
                              ₹ {convertToNextTenth(prodObject && prodObject.cashPrice)}
                            </span>
                          </h5>
                        </>
                      )}
                    </strong>
                  </span>
                </GridItem>
              </GridContainer>
              <h5 className={classes.mainPrice}>
                {cat.title +
                  "/" +
                  catMM.title +
                  "/ " +
                  (prodObject.readyGram * sets.pcs).toFixed(4) +
                  " Avg Gram of " +
                  sets.setDesc +
                  " and " +
                  box.boxDesc +
                  ", " +
                  prodObject.cartDescription}
              </h5>
              <h6 className={classes.mainPrice}>
                Minimum order: should be for {prodObject.moq} Box {"{"}
                {sets.setDesc + " and " + box.boxDesc}
                {"}"}. Product Delivery within 25 working days in India Please
                feel free to Contact Us @ 02247501787 {"/"} +91 9967457786{" "}
              </h6>
              <h5
                style={{
                  backgroundColor: "black",
                  width: "30%",
                  textAlign: "center",
                  color: "white",
                }}
              >
                {proTotal === 1 ? "In Stock" : "Make To Order"}
              </h5>
              <Accordion
                active={0}
                activeColor="info"
                collapses={[
                  {
                    title: "Size Charts",
                    content: (
                      <span>
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={12}>
                            <Tooltip
                              id="tooltip-top"
                              title="Click Here for Size Chart"
                              placement="top"
                              classes={{ tooltip: classes.tooltip }}
                            >
                              <a href="#">Bangles Size Chart</a>
                            </Tooltip>
                            <br />
                            <p style={{ color: "#999" }}>
                              The quantity of the order should be of minimum{" "}
                              {FullAndCutSizeTotal} Boxes
                            </p>
                            <p style={{ color: "#999" }}>
                              There should be a minimum of {totalPiece} boxes in
                              one size
                            </p>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={checkedFullSize}
                                  onChange={(event) =>
                                    setCheckedFullSize(event.target.checked)
                                  }
                                  value="checkedFullSize"
                                  classes={{
                                    switchBase: classe.switchBase,
                                    checked: classe.switchChecked,
                                    thumb: classe.switchIcon,
                                    track: classe.switchBar,
                                  }}
                                />
                              }
                              classes={{
                                label: classe.label,
                                root: classe.labelRoot,
                              }}
                              label={
                                checkedFullSize === false ? (
                                  <span>Full Size</span>
                                ) : (
                                  <span
                                    style={{
                                      color:
                                        checkedFullSize === true
                                          ? "#d81b60"
                                          : "",
                                    }}
                                  >
                                    Full Size
                                  </span>
                                )
                              }
                            />
                          </GridItem>
                        </GridContainer>

                        {checkedFullSize === true ? (
                          <GridContainer>
                            <GridItem xs={4} sm={4} md={4}>
                              <CustomInput
                                labelText="1x8"
                                id="1x8"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size1x8,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize1x8(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize1x8("0");
                                    } else if (value === "") {
                                      setSize1x8("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize1x8(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                              <Popover
                                classes={{
                                  paper: classPop.popover,
                                }}
                                open={Boolean(anchorElTop)}
                                anchorEl={anchorElTop}
                                onClose={() => setAnchorElTop(null)}
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "center",
                                }}
                                transformOrigin={{
                                  vertical: "bottom",
                                  horizontal: "center",
                                }}
                              >
                                <div
                                  className={
                                    classPop.popoverBody +
                                    " " +
                                    classes.textCenter
                                  }
                                >
                                  Quantity should be {totalPiece} or greater
                                  than {totalPiece} Boxes in Any Size.
                                </div>
                              </Popover>
                            </GridItem>
                            <GridItem xs={4} sm={4} md={4}>
                              <CustomInput
                                labelText="1x10"
                                id="1x10"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size1x10,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize1x10(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize1x10("0");
                                    } else if (value === "") {
                                      setSize1x10("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize1x10(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                            <GridItem xs={4} sm={4} md={4}>
                              <CustomInput
                                labelText="1x12"
                                id="1x12"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size1x12,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize1x12(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize1x12("0");
                                    } else if (value === "") {
                                      setSize1x12("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize1x12(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                            <GridItem xs={4} sm={4} md={4}>
                              <CustomInput
                                labelText="1x14"
                                id="1x14"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size1x14,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize1x14(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize1x14("0");
                                    } else if (value === "") {
                                      setSize1x14("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize1x14(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                            <GridItem xs={4} sm={4} md={4}>
                              <CustomInput
                                labelText="2x0"
                                id="2x0"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size2x0,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize2x0(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize2x0("0");
                                    } else if (value === "") {
                                      setSize2x0("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize2x0(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                            <GridItem xs={4} sm={4} md={4}>
                              <CustomInput
                                labelText="2x2"
                                id="2x2"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size2x2,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize2x2(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize2x2("0");
                                    } else if (value === "") {
                                      setSize2x2("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize2x2(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                            <GridItem xs={4} sm={4} md={4}>
                              <CustomInput
                                labelText="2x4"
                                id="2x4"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size2x4,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize2x4(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize2x4("0");
                                    } else if (value === "") {
                                      setSize2x4("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize2x4(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                            <GridItem xs={4} sm={4} md={4}>
                              <CustomInput
                                labelText="2x6"
                                id="2x6"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size2x6,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize2x6(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize2x6("0");
                                    } else if (value === "") {
                                      setSize2x6("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize2x6(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                            <GridItem xs={4} sm={4} md={4}>
                              <CustomInput
                                labelText="2x8"
                                id="2x8"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size2x8,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize2x8(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize2x8("0");
                                    } else if (value === "") {
                                      setSize2x8("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize2x8(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                            <GridItem xs={3} sm={3} md={3}>
                              <CustomInput
                                labelText="2x10"
                                id="2x10"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size2x10,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize2x10(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize2x10("0");
                                    } else if (value === "") {
                                      setSize2x10("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize2x10(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                            <GridItem xs={3} sm={3} md={3}>
                              <CustomInput
                                labelText="2x12"
                                id="2x12"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size2x12,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize2x12(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize2x12("0");
                                    } else if (value === "") {
                                      setSize2x12("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize2x12(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                            <GridItem xs={3} sm={3} md={3}>
                              <CustomInput
                                labelText="2x14"
                                id="2x14"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size2x14,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize2x14(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize2x14("0");
                                    } else if (value === "") {
                                      setSize2x14("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize2x14(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                            <GridItem xs={3} sm={3} md={3}>
                              <CustomInput
                                labelText="3x0"
                                id="3x0"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size3x0,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize3x0(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize3x0("0");
                                    } else if (value === "") {
                                      setSize3x0("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize3x0(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                        ) : (
                          ""
                        )}

                        <FormControlLabel
                          control={
                            <Switch
                              checked={checkedCutSize}
                              onChange={(event) =>
                                setCheckedCutSize(event.target.checked)
                              }
                              value="checkedCutSize"
                              classes={{
                                switchBase: classe.switchBase,
                                checked: classe.switchChecked,
                                thumb: classe.switchIcon,
                                track: classe.switchBar,
                              }}
                            />
                          }
                          classes={{
                            label: classe.label,
                            root: classe.labelRoot,
                          }}
                          label={
                            checkedCutSize === false ? (
                              <span>
                                Click here, If you have a requirement for Cut
                                Size
                              </span>
                            ) : (
                              <span
                                style={{
                                  color:
                                    checkedCutSize === true ? "#00acc1" : "",
                                }}
                              >
                                Cut Size
                              </span>
                            )
                          }
                        />

                        {checkedCutSize === true ? (
                          <GridContainer>
                            <GridItem xs={4} sm={4} md={4}>
                              <CustomInput
                                labelText="1x9"
                                id="1x9"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size1x9,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize1x9(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize1x9("0");
                                    } else if (value === "") {
                                      setSize1x9("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize1x9(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                              <Popover
                                classes={{
                                  paper: classPop.popover,
                                }}
                                open={Boolean(anchorElTop)}
                                anchorEl={anchorElTop}
                                onClose={() => setAnchorElTop(null)}
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "center",
                                }}
                                transformOrigin={{
                                  vertical: "bottom",
                                  horizontal: "center",
                                }}
                              >
                                <div
                                  className={
                                    classPop.popoverBody +
                                    " " +
                                    classes.textCenter
                                  }
                                >
                                  Quantity should be {totalPiece} or greater
                                  than {totalPiece} Boxes in Any Size.
                                </div>
                              </Popover>
                            </GridItem>
                            <GridItem xs={4} sm={4} md={4}>
                              <CustomInput
                                labelText="1x11"
                                id="1x11"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size1x11,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize1x11(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize1x11("0");
                                    } else if (value === "") {
                                      setSize1x11("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize1x11(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                            <GridItem xs={4} sm={4} md={4}>
                              <CustomInput
                                labelText="1x13"
                                id="1x13"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size1x13,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize1x13(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize1x13("0");
                                    } else if (value === "") {
                                      setSize1x13("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize1x13(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                            <GridItem xs={4} sm={4} md={4}>
                              <CustomInput
                                labelText="1x15"
                                id="1x15"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size1x15,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize1x15(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize1x15("0");
                                    } else if (value === "") {
                                      setSize1x15("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize1x15(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                            <GridItem xs={4} sm={4} md={4}>
                              <CustomInput
                                labelText="2x1"
                                id="2x1"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size2x1,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize2x1(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize2x1("0");
                                    } else if (value === "") {
                                      setSize2x1("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize2x1(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                            <GridItem xs={4} sm={4} md={4}>
                              <CustomInput
                                labelText="2x3"
                                id="2x3"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size2x3,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize2x3(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize2x3("0");
                                    } else if (value === "") {
                                      setSize2x3("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize2x3(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                            <GridItem xs={4} sm={4} md={4}>
                              <CustomInput
                                labelText="2x5"
                                id="2x5"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size2x5,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize2x5(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize2x5("0");
                                    } else if (value === "") {
                                      setSize2x5("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize2x5(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                            <GridItem xs={4} sm={4} md={4}>
                              <CustomInput
                                labelText="2x7"
                                id="2x7"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size2x7,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize2x7(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize2x7("0");
                                    } else if (value === "") {
                                      setSize2x7("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize2x7(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                            <GridItem xs={4} sm={4} md={4}>
                              <CustomInput
                                labelText="2x9"
                                id="2x9"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size2x9,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize2x9(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize2x9("0");
                                    } else if (value === "") {
                                      setSize2x9("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize2x9(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                            <GridItem xs={3} sm={3} md={3}>
                              <CustomInput
                                labelText="2x11"
                                id="2x11"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size2x11,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize2x11(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize2x11("0");
                                    } else if (value === "") {
                                      setSize2x11("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize2x11(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                            <GridItem xs={3} sm={3} md={3}>
                              <CustomInput
                                labelText="2x13"
                                id="2x13"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size2x13,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize2x13(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize2x13("0");
                                    } else if (value === "") {
                                      setSize2x13("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize2x13(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                            <GridItem xs={3} sm={3} md={3}>
                              <CustomInput
                                labelText="2x15"
                                id="2x15"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size2x15,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize2x15(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize2x15("0");
                                    } else if (value === "") {
                                      setSize2x15("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize2x15(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                            <GridItem xs={3} sm={3} md={3}>
                              <CustomInput
                                labelText="3x1"
                                id="3x1"
                                number
                                inputProps={{
                                  placeholder: totalPiece,
                                  value: size3x1,
                                  onChange: (e) => {
                                    const { value } = e.target;
                                    setSize3x1(value);
                                  },
                                  onBlur: (e) => {
                                    const { value } = e.target;
                                    if (value === "0") {
                                      setSize3x1("0");
                                    } else if (value === "") {
                                      setSize3x1("0");
                                    } else if (value < totalPiece) {
                                      setAnchorElTop(e.currentTarget);
                                      setSize3x1(totalPiece);
                                    }
                                  },
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                        ) : (
                          ""
                        )}
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={12}>
                            <p style={{ color: "#999" }}>
                              Full Size Total {indianQty} & Cut Size Total{" "}
                              {usQty}
                            </p>
                            <p style={{ color: "red" }}>
                              Total quantity : {indianQty + usQty} & Order Value
                              ₹{" "}
                              {prodObject.gstCash === true
                                ? (
                                  prodObject.taxInclude *
                                  (indianQty + usQty)
                                ).toFixed(2)
                                : (
                                  prodObject.cashPrice *
                                  (indianQty + usQty)
                                ).toFixed(2)}
                            </p>
                            <p>
                              If you have any additional requirements or changes
                              for your order.
                            </p>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                            <CustomInput
                              labelText="Comment"
                              id="comment"
                              number
                              inputProps={{
                                placeholder:
                                  "Mix different four sizes in one design, or mix different six designs in one size.",
                                value: comment,
                                multiline: true,
                                rows: 5,
                                onChange: (e) => setComment(e.target.value),
                              }}
                              formControlProps={{
                                fullWidth: true,
                              }}
                            />
                          </GridItem>
                        </GridContainer>
                      </span>
                    ),
                  },
                  {
                    title: "Product Details and Care",
                    content: (
                      <ul>
                        <li>
                          Durability only for a period of (6) months from the
                          date of sale(Not for spoilage or breakage invalid if
                          not stamped).
                        </li>
                        <li>
                          Please wash this piece with soap and warm water & wipe
                          it with soft cotton cloth for longer life.
                        </li>
                      </ul>
                    ),
                  },
                ]}
              />
              {activeSession ? (
                <Button round color="rose" onClick={handleEnquiry}>
                  Enquiry&nbsp; <ShoppingCart />
                </Button>
              ) : (
                <Link
                  to={`/list?a=${a}&p=${p}&category=${category}&catSize=${catSize}&country=${country}&state=${state}&d=o`}
                >
                  <Button
                    round
                    color="rose"
                  // onClick={() => setLogMsg("Go to Log In")}
                  >
                    Enquiry&nbsp; <ShoppingCart />
                  </Button>
                </Link>
              )}{" "}
            </GridItem>
          </GridContainer>
          {/* <GridContainer>
            {infoList.map((info, index) => (
              <GridItem key={index} md={2} sm={6}>
                <div
                  className={classesPop.infoClickable}
                  onClick={(e) => handleIconClick(e, info)}
                >
                  <InfoArea
                    title={info.title}
                    description="" // hide inline description
                    icon={info.icon}
                    iconColor={info.iconColor}
                    vertical
                  />
                </div>
              </GridItem>
            ))}
          </GridContainer> */}

          <GridContainer className={classesPop.infoGrid}>
            {infoList.map((info, index) => (
              <GridItem key={index} md={2} sm={2} className={classesPop.infoItem}>
                <div
                  className={classesPop.infoClickable}
                  onClick={(e) => handleIconClick(e, info)}
                >
                  <InfoArea
                    title={info.title}
                    description=""
                    icon={info.icon}
                    iconColor={info.iconColor}
                    vertical
                    className={classesPop.infoArea}
                  />
                </div>
              </GridItem>
            ))}
          </GridContainer>

          {/* 🔹 Shared Popover */}
          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            PaperProps={{ className: classesPop.popoverPaper }}
          >
            {selectedInfo && (
              <div className={classesPop.popoverInner}>
                <div className={classesPop.popoverHeader}>
                  <Typography className={classesPop.title}>
                    {selectedInfo.title}
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={handleClose}
                    aria-label="close"
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </div>
                <Typography className={classesPop.description} variant="body2">{selectedInfo.description}</Typography>
              </div>
            )}
          </Popover>
          <br />
          <br />
          <hr />
        </div>
      </div>
    </div>
  );
}
